import React from "react";
import {FlexCol, FlexRow} from "../generic/Containers";
import {Subtitle1, useWelcomeSpring} from "../generic/BCHeaders";
import {STRINGS} from "../../constants/Strings";
import {BCPrimaryButton} from "../generic/BCButtons";
import {BCIcon, ICONS} from "../generic/BCIcons";
import {animated} from "@react-spring/web";
import {useGlobalState} from "../../GlobalState";
import HeroImage from "../../images/new-hero-image.svg";
import "./HeroBanner.css";

export const HeroBanner: React.FC<{isEducator: boolean}> = ({isEducator}) => {
    const { isPremium, isAuthenticated, setShowAuthModal, setAuthModalMode, setShowEducatorInquiryModal } = useGlobalState();
    const welcomeSpring = useWelcomeSpring();
    const subtitle = STRINGS.LANDING_PAGE_HERO_COMPONENT_SUBTITLE
    const ctaText = STRINGS.LANDING_PAGE_HERO_COMPONENT_CTA
    return (
        <animated.div style={welcomeSpring}>
            <FlexCol widthPercent={100} gap={1.5} align="center"
                style={{
                    position: 'relative',
                    overflow: 'hidden',
                }}
            >
                <FlexRow gap={1.5} widthPercent={100} pVertical={3} align="center" className="hero-banner-row" style={{position: 'relative', zIndex: 1}}>
                    <FlexCol gap={1} align="flex-start" widthPercent={50} className="hero-banner-text-col">
                        <h1 className="hero-banner-title">
                            Turn Coding Skills Into<br/>
                            <span style={{ color: 'var(--color-accent)' }}>Job Offers</span>
                        </h1>
                        <Subtitle1
                            text={subtitle}
                            className={`hero-banner-subtitle ${isEducator ? 'educator-version' : ''}`}
                        />
                        {!isAuthenticated && <BCPrimaryButton
                            className={`dashboard-primary-cta ${isEducator ? 'educator-version' : ''}`}
                            style={{ width: '100%', maxWidth: '280px' }}
                            text={ctaText} onClick={() => {
                            if (isEducator) {
                                setShowEducatorInquiryModal(true);
                            } else {
                                setAuthModalMode('register');
                                setShowAuthModal(true);
                            }
                        }}/>}
                        {!isAuthenticated && <HeroTestimonialComponent /> }
                    </FlexCol>
                    <div className="hero-banner-image-col" style={{
                        width: '50%',
                        borderRadius: '0.6em',
                        overflow: 'hidden',
                        position: 'relative',
                        boxShadow: `0 4px 12px 20`
                    }}>
                        <img src={HeroImage} alt="Hero image"
                             style={{
                                 width: '100%',
                                 height: '100%',
                                 objectFit: 'cover'
                             }}
                        />
                    </div>
                </FlexRow>
            </FlexCol>
        </animated.div>
    )
}

export const HeroTestimonialComponent: React.FC = () => {
    return (
        <FlexRow className={'hero-testimonial-component'} gap={1} align="center" mTop={0.5}>
            <p style={{color: 'var(--secondary-text-color)', fontSize: '0.875rem', fontWeight: 300}}>
                Join <span style={{fontWeight: 700, color: 'var(--text-color)'}}>2500+</span> Happy Developers
            </p>
            <FlexRow gap={0.25} align="center">
                {[...Array(5)].map((_, index) => (
                    <BCIcon
                        key={index}
                        icon={ICONS.RATING_STAR}
                        style={{color: '#FFB800', fontSize: '1.2em'}}
                    />
                ))}
            </FlexRow>
        </FlexRow>
    )
}
